import React from "react";
import "./Team.css";

const Team = () => {
  return (
    <div className="team_parent_div">
      <h1>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laudantium,
        corrupti?
      </h1>
    </div>
  );
};

export default Team;
